import { defineComponent as _defineComponent } from 'vue'
import { computed, ComputedRef, onMounted, ref } from 'vue';
import useStore from '@/utils/store/common';
import { INavigation } from '@/store/modules/devices/types';
import { Suggestions } from 'ctp-search-device';
import moment from 'moment';
import { colors } from '@/constants/theme/colors';
import { FilterGroup } from 'ctp-filter-group-management';
import FilterBookmarks from './components/FilterBookmarks.vue';
import AddBookmarkDialog from './components/AddBookmarkDialog.vue';
import FilterItem from './components/FilterItem.vue';
import './styles/list-filters.scss';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListFilters',
  setup(__props) {

const store = useStore();

const getNavigationConfiguration: ComputedRef<INavigation> = computed(() => store.getters['devices/getNavigationConfiguration']);
const getSuggestions: ComputedRef<Suggestions> = computed(() => store.getters['devices/getSuggestions']);
const getVariants: ComputedRef<Suggestions> = computed(() => store.getters['tollDomain/getVariants']);

const displayDate = (seconds: number) => moment().subtract(seconds, 'seconds').format('DD/MM/YYYY');
const displayVariant = (ids: number[]) => {
  const variants = ids.map(variant => store.getters['tollDomain/getVariantById'](variant)?.name);
  return variants.join(', ');
};

const displayMoreFilters = ref(false);
const multiSearch = ref('');
const activeFiltersCount = ref(0);
const selectedFilters = ref<{ id: string, values: string[] }[]>([]);
const appliedFilters = ref<{ [key: string]: any }[]>([]);
const resetedFilters = ref<string[]>([]);
const reset = ref(false);
const resetMe = ref('');

function applyFilters(fetchDevices = true) {
  // Save filters to store
  store.dispatch('devices/saveDeviceFilters', { selectedFilters: selectedFilters.value, multiSearch: multiSearch.value });
  const filters: {[key: string]: any} = {};
  resetMe.value = '';
  resetedFilters.value = [];
  // Push all selected filters
  if (selectedFilters.value.length > 0) {
    selectedFilters.value.forEach((item) => {
      filters[item.id] = item.values;
    });
  }
  // Push multisearch bar values
  if (multiSearch.value !== '') {
    activeFiltersCount.value = 1;
    filters.identifierMatchers = multiSearch.value.replace(/ /g, '').split(',');
  }
  const newNavigationConfiguration = {
    ...getNavigationConfiguration
  };
  newNavigationConfiguration.value.filters = filters;
  newNavigationConfiguration.value.start = 0;
  // Fix bug 12427: chips stay opened even with no value inside
  appliedFilters.value = Object.entries(filters)
    .filter(([_, value]) => {
      if (value == null) return false;
      if (Array.isArray(value) && value.length === 0) return false;
      if (typeof value === 'string' && value.trim() === '') return false;
      return true;
    })
    .map(([key, value]) => ({ [key]: value }));
  if (fetchDevices) store.dispatch('devices/updateNavigation', { ...newNavigationConfiguration.value });
}

onMounted(() => {
  // Load existing filters, existing filters are applied at devicelist level DevicesList -> LoadList
  const savedFilters = sessionStorage.getItem('savedFilters');
  if (!savedFilters) return;
  selectedFilters.value = JSON.parse(savedFilters).selectedFilters;
  multiSearch.value = JSON.parse(savedFilters).multiSearch;
  applyFilters(false);
});

function toggleMoreFilters() {
  displayMoreFilters.value = !displayMoreFilters.value;
}

function updateFilters(key: string, val: string[]) {
  const index = selectedFilters.value.findIndex(item => item.id === key);
  if (index !== -1) {
    selectedFilters.value[index].values = val;
  } else {
    selectedFilters.value.push({ id: key, values: val });
  }
}

function resetFilterValues() {
  selectedFilters.value = [];
  multiSearch.value = '';
  activeFiltersCount.value = 0;
  appliedFilters.value = [];
  resetedFilters.value = [];
  reset.value = true;
  sessionStorage.removeItem('savedFilters');
}

function resetFilters() {
  resetFilterValues();
  const newNavigationConfiguration = {
    ...getNavigationConfiguration
  };
  newNavigationConfiguration.value.filters = {};
  newNavigationConfiguration.value.start = 0;
  store.dispatch('devices/updateNavigation', { ...newNavigationConfiguration.value });
}

const triggerReset = (filterID: string) => {
  resetMe.value = filterID;
  resetedFilters.value.push(filterID);
};

function removeFilter(f: any) {
  if (f.identifierMatchers) {
    multiSearch.value = '';
  } else {
    selectedFilters.value = selectedFilters.value.filter(item => item.id !== Object.keys(f)[0]); // enlève les chip
  }
  triggerReset(Object.keys(f)[0]);
}

function applyBookmark(bookmark: FilterGroup) {
  resetFilterValues();
  Object.entries(JSON.parse(bookmark.filters)).forEach(([key, values]: any) => {
    if (key === 'device_ids') {
      multiSearch.value = values.join(',');
    } else {
      selectedFilters.value.push({ id: key, values });
    }
  });
  applyFilters();
}

const isReset = computed(() => (f: any) => resetedFilters.value.includes(Object.keys(f)[0]));

return { __sfc: true,store, getNavigationConfiguration, getSuggestions, getVariants, displayDate, displayVariant, displayMoreFilters, multiSearch, activeFiltersCount, selectedFilters, appliedFilters, resetedFilters, reset, resetMe, applyFilters, toggleMoreFilters, updateFilters, resetFilterValues, resetFilters, triggerReset, removeFilter, applyBookmark, isReset, colors, FilterBookmarks, AddBookmarkDialog, FilterItem }
}

})